import { createFileRoute } from "@tanstack/react-router";
import { GuidanceEditorPage } from "../../../../components/system/GuidanceEditorPage";
import { requireSuperAdmin } from "../../../../lib/auth/route-protection";

export const Route = createFileRoute("/system/insights/guidance/$catalogAlertId")({
  beforeLoad: requireSuperAdmin(),
  component: GuidanceEditorRoute,
});

function GuidanceEditorRoute() {
  const { catalogAlertId } = Route.useParams();
  return <GuidanceEditorPage key={catalogAlertId} catalogAlertId={catalogAlertId} />;
}
